<template>
  <div id="app" class="bg-beige-01">

    <div class="container-fluid">
      <div class="row justify-content-center bg-primary">
        <div class="col width-1140 ie-flex-col">
          <top-menu class="text-regular"></top-menu>
        </div>
      </div>
    </div>

    <div class="container main-contain-reg">
      <div class="row justify-content-center main-contain-inner">
        <div class="col">
          <page-heading-info
          title="Friendship Park - Jefferson County, Oh"
          phone="(740) 733-7941"
          email="friendshippark@jeffersoncountyoh.com"
          >
            <address-simple
            line1="Friendship Park Board District "
            line2="PO Box 4004"
            line3="Steubenville, OH 43952"
            ></address-simple>

            <div class="row mt-3">
              <div class="col-xs-1 icon-width">
                <i class="material-icons text-success">place</i>
              </div>

              <div class="col-xs-11">  
                <a href="https://www.google.com/maps/@40.2900521,-80.785171,15z" target="blank">Directions To Park</a>
              </div>
            </div>
          </page-heading-info>

          <router-view />
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-center footer-container bg-primary text-light">
        <div class="col width-1140 ie-flex-col">
          <footer-menu class="text-regular"></footer-menu>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>

import TopMenu from '@/components/menu/TopMenu.vue'
import FooterMenu from '@/components/menu/FooterMenu.vue'
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import AddressSimple from '@/components/layout/AddressSimple.vue'

export default {
  components: {
    TopMenu,
    FooterMenu,
    PageHeadingInfo,
    AddressSimple
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style>

.link-button {
  padding: 8px;
}

.width-1140 {
  width: 100%;
  max-width: 1140px;
}

.main-contain-reg > div {
  min-height: 900px;
  padding-top: 0px;
}

.main-contain-inner {
  margin-bottom: 24px;
}

.footer-container a {
  color: #ffffff;
}

.button-hover {
  cursor: pointer;
}
</style>
